import { InstanceScreen } from 'component/navigation/instance';

export default function VideoVotingIndexScreen() {
    return <InstanceScreen />;
}
